export default {"src":"/_next/static/media/email-sent.c8274086.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};